// Test IDs for Lunar Legacies Space Memorabilia Auction Platform
export const LUNAR = {
  // Navigation
  navLogo: 'nav-logo',
  navHome: 'nav-home-link',
  navFeatured: 'nav-featured-link',
  navUpcoming: 'nav-upcoming-link',
  navPast: 'nav-past-link',
  navConsign: 'nav-consign-link',
  navDashboard: 'nav-dashboard-link',
  navAuthButton: 'nav-auth-button',
  navLogoutButton: 'nav-logout-button',

  // Hero Section
  heroTitle: 'hero-title',
  heroSubtitle: 'hero-subtitle',
  heroCtaConsign: 'hero-cta-consign',
  heroCtaAuctions: 'hero-cta-auctions',

  // Artifact Catalog & Listing
  artifactCard: 'artifact-card',
  artifactTitle: 'artifact-title',
  artifactCategory: 'artifact-category',
  artifactBidAmount: 'artifact-current-bid-amount',
  artifactSaveButton: 'artifact-save-button',
  artifactBidButton: 'artifact-bid-button',
  artifactDetailModal: 'artifact-detail-modal',

  // Bidding Modal
  bidModalInput: 'bid-modal-input',
  bidModalSubmit: 'bid-modal-submit',
  bidModalCancel: 'bid-modal-cancel',
  bidModalError: 'bid-modal-error',
  bidModalSuccess: 'bid-modal-success',

  // Consignment Wizard
  consignStepIndicator: 'consign-step-indicator',
  consignInputTitle: 'consign-input-title',
  consignSelectCategory: 'consign-select-category',
  consignInputDescription: 'consign-input-description',
  consignInputCondition: 'consign-input-condition',
  consignRunAiValuation: 'consign-run-ai-valuation',
  consignAiValuationOutput: 'consign-ai-valuation-output',
  consignDragDropZone: 'consign-drag-drop-zone',
  consignNextStep: 'consign-next-step',
  consignPrevStep: 'consign-prev-step',
  consignSubmitBtn: 'consign-submit-btn',
  consignSuccessMessage: 'consign-success-message',

  // User Dashboard
  dashboardWelcome: 'dashboard-welcome-message',
  dashboardTabBids: 'dashboard-tab-bids',
  dashboardTabConsignments: 'dashboard-tab-consignments',
  dashboardTabSaved: 'dashboard-tab-saved',
  dashboardBidsTable: 'dashboard-bids-table',
  dashboardConsignmentsTable: 'dashboard-consignments-table',
  dashboardSavedGrid: 'dashboard-saved-grid',
  dashboardConsignmentStatus: 'dashboard-consignment-status-badge',

  // Authentication forms
  loginCard: 'login-card',
  loginEmailInput: 'login-email-input',
  loginPasswordInput: 'login-password-input',
  loginSubmitBtn: 'login-submit-button',
  loginToggleRegister: 'login-toggle-register',
  loginErrorMessage: 'login-error-message',

  registerCard: 'register-card',
  registerNameInput: 'register-name-input',
  registerEmailInput: 'register-email-input',
  registerPasswordInput: 'register-password-input',
  registerSubmitBtn: 'register-submit-button',
  registerToggleLogin: 'register-toggle-login',
  registerErrorMessage: 'register-error-message',

  // Alert/Toast
  toastNotification: 'toast-notification'
};
